/**
 * Self-host (ADR-0041): CSP dış font yasağını korur, ağ isteği yok. `index.css`'den ÖNCE
 * import edilir ki `--font-sans` token'ı Manrope'u kullanırken font yüklenmiş olsun.
 */
import "@fontsource-variable/manrope";
import "./styles/index.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Kök eleman bulunamadı: #root");

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
